import { getAppVersion, compareVersion } from 'root/common/util/getAppVersion';
import config from 'root/common/config/config';
import env from 'root/common/util/env';

let deviceready = false;
const UA = window.ZZCFL.Utils.UA;
export const isIos = UA.os.name == 'ios';
export const isAndroid = UA.os.name == 'android';

const readyPromise = new Promise(res => document.addEventListener('deviceready', res, false)).then(
    () => (deviceready = true)
);

/**
 * Promise的方式调用window.zzc.call，可以用await调用
 * 当response.state != 0时抛出错误
 * @example const response = await zzcCall('base_localStorageGetItem', { key, namespace });
 * @param {string} api
 * @param {*} opt
 */
export function zzcCall(api, opt) {
    if (!deviceready) {
        return readyPromise.then(() => zzcCall(api, opt));
    }
    return new Promise((res, ret) => {
        window.zzc.call(api, {
            ...opt,
            success: function(response) {
                if (response.state == 0) res(response);
                else ret(new Error(response.message));
            },
            complete: function(response) {
                if (response.state == 0) res(response);
                else ret(new Error(response.message));
            },
            error: ret,
        });
    });
}

/**
 * 监听页面显示隐藏
 * callback true , 表示显示，false ， 表示隐藏
 */
export function onVisibilityChange(callback) {
    const listener = function(res) {
        // 原生插件命名问题。hidden为false，表示进入页面。。。。
        let isShow = res.hidden;
        callback(isShow);
    };
    window.zzc.on('visibilitychange', listener);
    return () => window.zzc.off('visibilitychange', listener);
}

/**
 * 监听页面显示隐藏
 * callback true , 表示显示，false ， 表示隐藏
 */
export function onVisibilityChangeOnce(callback) {
    console.log('call native : onVisibilityChange');
    window.zzc.once('visibilitychange', function(res) {
        callback(res.hidden);
    });
}

/**
 * 返回到上一页
 */
export function backToPreviousPage() {
    console.log('native call : to back');
    return new Promise(resolve => {
        window.zzc.call('base_backToPreviousPage', {
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 销毁指定页面(实现app后退跳过某些页面功能)
 *
 * @param {[string]} urls
 */
export function appDestroyPage(urls) {
    console.log('native call : to destroyPage');
    return new Promise((resolve, reject) => {
        if (window.zzc && window.zzcjsbridge.base_destroyPage) {
            window.zzc.call('base_destroyPage', {
                urls,
                success: function(response) {
                    resolve(response);
                },
            });
        } else {
            reject();
        }
    });
}

/**
 * 获取用户信息
 */
export function accountGetInfo() {
    console.log('native call : account_getInfo');
    return new Promise(resolve => {
        document.addEventListener(
            'deviceready',
            function() {
                if (window.zzcjsbridge && window.zzcjsbridge.account_getInfo) {
                    window.zzc.call('account_getInfo', {
                        success(response) {
                            // console.log(response.data); //data->{"userId":xxx,"token":xxx}
                            resolve(response);
                        },
                    });
                }
            },
            false
        );
    });
}

// 安卓，监听物理
export function listenerAndroidBackBtn(callback) {
    if (isAndroid) {
        document.addEventListener(
            'deviceready',
            function() {
                window.zzc && window.zzc.call('base_listenBackButton');
                if (callback) {
                    window.zzc &&
                        window.zzc.on('app:backButtonClick', function() {
                            callback();
                        });
                } else {
                    window.zzc && window.zzc.on('app:backButtonClick');
                }
            },
            false
        );
    }
}

/**
 * 禁止手势返回
 *
 * @date 2019-09-16
 * @export
 */
export function appNoGestures({ callback, off = 1 }) {
    if (isAndroid) {
        document.addEventListener(
            'deviceready',
            function() {
                window.zzc && window.zzc.call('base_listenBackButton');
                if (callback) {
                    window.zzc &&
                        window.zzc.on('app:backButtonClick', function() {
                            callback();
                        });
                } else {
                    window.zzc && window.zzc.on('app:backButtonClick');
                }
            },
            false
        );
    } else if (isIos) {
        window.zzc &&
            window.zzc.call('base_controlLeftPanGesture', {
                off, // 操作枚举值
                success: function(response) {
                    console.log('response: ', response);
                },
                listener: function(response) {
                    console.log('off3,response', response);
                },
            });
    }
}

/**
 * app返回多少页（ios1.16.0之前的版本都是取正值）
 *
 * @date 2019-09-20
 * @export
 * @param {*} back
 */
export function appHistoryGo(back) {
    if (isIos && window.__is_blackApp) {
        let version = getAppVersion();
        console.log('compareVersio: ', compareVersion('1.16.0', '1.16.0'));
        if (compareVersion(version, '1.16.0') == -1) {
            back = Math.abs(back);
        }
    }

    if (window.__is_blackApp) {
        window.zzc &&
            window.zzcjsbridge.base_goBackPage &&
            window.zzc.call('base_goBackPage', {
                step: back,
                success: function(response) {
                    console.log(response);
                },
            });

        return false;
    }
    history.go(back);
}

// 图片预览
export function imageViewer(data = {}) {
    return new Promise(resolve => {
        window.zzc.call('ImageViewer', {
            title: data.title,
            photos: data.photos,
            showIndex: data.showIndex,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 获取App机器码相关信息
 *
 * @date 2019-11-13
 * @export
 */
export async function getAppIDInfo() {
    if (!canUse('base_localStorageGetItem')) {
        return null;
    }
    if (env.isAppVest) {
        return null;
    }

    try {
        // idfa码，只有ios有
        const idfaResponse = await zzcCall('base_localStorageGetItem', {
            key: 'IDFA',
            namespace: env.isIos ? 'vipCard' : '',
        });
        // 通用utdid码
        const utdidResponse = await zzcCall('base_localStorageGetItem', {
            key: 'UTDID',
            namespace: env.isIos ? 'vipCard' : '',
        });
        const IDFA = idfaResponse.data || '';
        const UTDID = utdidResponse.data || '';
        if (!IDFA && !UTDID) {
            return null;
        }
        return {
            IDFA: IDFA,
            UTDID: UTDID,
        };
    } catch (error) {
        return null;
    }
}

/**
 * 获取地理位置
 */
export function getLocation(tips = '') {
    console.log('native call : get location');
    return new Promise(resolve => {
        window.zzc.call('base_requestLocation', {
            tips: tips, // 动态权限申请时（如果未授予定位权限）应用弹框的文案，为空时app使用默认的文案（注：iOS无法动态修改权限文案）
            complete: function(res) {
                // 由于 state != 0 没进success , 所以使用complete
                resolve(res);
            },
        });
    });
}

/**
 * 检查对应的插件方法是否可用
 * @param {} name
 */
export function canUse(name) {
    return !!(window.zzcjsbridge && window.zzcjsbridge[name]);
}

/**
 * 检查对应的插件方法是否可用，保证插件可用后检测
 * @param {} name
 */
export function canUseOnReady(name) {
    if (!canUse(name)) {
        return;
    }
    return new Promise(resolve => {
        document.addEventListener(
            'deviceready',
            function() {
                resolve(!!(window.zzcjsbridge && window.zzcjsbridge[name]));
            },
            false
        );
    });
}

/**
 * 获取地理位置
 */
export function getLocationNew(tips = '') {
    console.log('native call : get location');
    return new Promise(resolve => {
        window.zzc.call('base_requestLocation_new', {
            tips: tips, // 动态权限申请时（如果未授予定位权限）应用弹框的文案，为空时app使用默认的文案（注：iOS无法动态修改权限文案）
            complete: function(res) {
                // 由于 state != 0 没进success , 所以使用complete
                resolve(res);
            },
        });
    });
}

/**
 * 打开导航
 */
export function openLocation(options) {
    console.log('native call : open location');
    console.log(options);
    return new Promise(resolve => {
        window.zzc.call('startNavigate', {
            success: function(res) {
                resolve(res);
            },
            ...options,
        });
    });
}

// http://wiki.int.zuzuche.info/pages/viewpage.action?pageId=109511835
export function fetchData({ url, dataType, timeout }) {
    return new Promise((resolve, reject) => {
        timeout &&
            setTimeout(() => {
                reject(new Error('请求超时,请稍后再试'));
            }, timeout);
        window.zzc.call('fetchData', {
            url,
            dataType,
            success(res) {
                resolve(res);
            },
        });
    });
}

/**
 * 获取百川授权信息
 * 响应内容：
 * {
 *      "state": 0, // 0表示成功，其他为错误
 *      "message": "",  // 错误原因
 *      "data":{
 *          "nick":"xxx",
 *          "avatarUrl":"xxx",
 *          "openId":"xxx",
 *          "openSid":"xxx"
 *      }
 *  }
 */
export function callTaoBaoLogin() {
    console.log('call native : taoBaoLogin');
    return new Promise(resolve => {
        window.zzc.call('alibc_login', {
            complete: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 确保淘宝登录状态，如果淘宝未登录，返回null
 */
export async function ensuerTaoBaoLogin() {
    try {
        const res = await zzcCall('alibc_login');
        if (res.message === 'error') return null;
        return res.data;
    } catch (error) {
        return null;
    }
}

/**
 * 检测淘宝登录态
 */
export async function isTaobaoLogin() {
    try {
        const res = await zzcCall('alibc_isLogin');
        return res.data;
    } catch (error) {
        return null;
    }
}

/**
 * 检查是否有权限
 */
export function jumpPermissionSetting() {
    return new Promise(resolve => {
        window.zzc.call('jump_permission_setting', {
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 百川 SDK 升级版本
 * 通过百川SDK跳转到淘宝页面
 */
export function showTaoBaoWebPageV2(data) {
    console.log('call native : showAli_TradePage v2');
    return new Promise(resolve => {
        let reqData = {
            // itemId: 'https://item.taobao.com/item.htm?id=580106182027',
            // 打开百川方式：100 ：openByBizCode  101 ：openByUrl
            pageType: 101,
            identity: 'trade',
            ...data,
        };

        window.zzc.call('showAli_TradePage', {
            ...reqData,
            success: function(response) {
                resolve(response);
            },
        });
    });
}
/**
 * 检查是否有权限
 */
export function hasPermissions(permissions) {
    return new Promise(resolve => {
        window.zzc.call('native_hasPermissions', {
            permissions: permissions,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 打开淘宝页面
 * @param {*} data
 * pageType : int类型（取值 0：DetailPage（商品详情页） , 1:ShopPage（店铺页面） , 2:UrlPage（url展示页面） , 3:MyOrderPage（我的订单页面） , 4:MyCartsPage（我的购物车页面）, 5:AddCartPage（加入购物车页面）, 6:MiniDetailPage（mini商品详情页））
 */
export function showTaoBaoWebPage(data) {
    console.log('call native : callTaoBaoWebPage');
    return new Promise(resolve => {
        let reqData = {
            // itemId: 'https://item.taobao.com/item.htm?id=580106182027',
            pageType: 2,
            pid: '', // pid/unionId/subPid 淘宝联盟参数(为空则调用本地默认配置)
            ...data,
        };

        window.zzc.call('alibc_showWebPage', {
            ...reqData,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 检查是否有权限
 */
export function requestPermissions(permission) {
    return new Promise(resolve => {
        window.zzc.call('native_requestPermissions', {
            permission: permission,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

export function baseShare(appShareData = {}) {
    const defaultData = {
        title: '',
        content: '',
        photo: '',
        isShowPreview: true,
        photoUrl: '', // 此字段如果有值，原生接收到后就展示位分享单图的形式。无值原生展示形式为原本分享title content的形式
        drivingClubUrl: '', // 分享到自驾圈的链接
        shareUrl: '',
        sharePlatform: ['wxsession', 'wxtimeline', 'copy'], // 可选，不传默认支持wxsession、wxtimeline、qq、sina、copy, 如果要分享到自驾圈，值为：drivingClub
        photoShareBase64: null,
        photoSharePlatform: null,
    };
    const finalData = Object.assign(defaultData, appShareData);
    console.log('base_share', defaultData, finalData, finalData.photoShareBase64);
    window.zzc.call('base_share', finalData);
}

/**
 *
 * 分享微信小程序: http://wiki.black-unique.com/pages/viewpage.action?pageId=299336368
 * @export
 * @param {Object} params
 * @param {String} params.base64Str 小程序消息封面图片，小于128k——优先使用(注意不能带data:image/*开头)
 * @param {String} params.imageUrl 小程序消息封面图片，小于128k
 * @param {String} params.miniProgramId（必须）小程序原始id
 * @param {String} params.programPath  (必须）小程序页面路径；
 * @param {String} params.webPageUrl //（必须）兼容低版本的网页链接
 * @param {String} params.appId //移动应用AppId，默认使用原生保存的AppId（注意不是小程序的APPID,一般不用传）
 * @param {String} params.miniProgramType (默认使用正式版）正式版:0，测试版:1，体验版:2
 * @param {String} params.shareTitle // 小程序消息title
 * @returns {Promise}
 */
export function shareWxMiniProgram(params) {
    return new Promise(resolve => {
        window.zzc.call('shareWxMiniProgram', {
            ...params,
            complete: function(response) {
                console.log(response); //response.state == 0：成功，response.state == 1001参数错误
                resolve(response);
            },
        });
    });
}
/**
 * 监听 onload 方法 ，有些插件需要load后再调用
 * @param {} callback
 */
export function ready() {
    if (!deviceready) {
        return readyPromise;
    } else {
        return Promise.resolve();
    }
}

/**
 * 调起广告插件
 * @param {Object} param
 * @param {string} param.iosSlotId ios的slotId
 * @param {string} param.androidSlotId android的slotId
 */
export function playRewardAdVideo({ iosSlotId, androidSlotId }) {
    return new Promise(resolve => {
        window.zzc.call('playRewardAdVideo', {
            slotId: isAndroid ? androidSlotId : iosSlotId,
            success: resolve,
        });
    });
}

// http://wiki.int.zuzuche.info/pages/viewpage.action?pageId=99680309
export function payCheckoutPlatform({ platforms }) {
    return new Promise(resolve => {
        if (window.zzc && window.zzcjsbridge.pay_checkoutPlatform) {
            window.zzc.call('pay_checkoutPlatform', {
                platforms,
                success(res) {
                    resolve(res);
                },
            });
        } else {
            resolve();
        }
    });
}

/* 添加顶部栏按钮
 * @param {Array} param.items 配置自定义导航栏右侧按钮
 */
export function setNavbarRightButtons(data) {
    return new Promise(resolve => {
        window.zzc.call('base_customNavbarRightButton', {
            ...data,
            success(res) {
                resolve(res);
            },
        });
    });
}

/**
 * 设置头部标题
 * @param {*} title
 */
export function setTitle(title) {
    window.zzc.call('base_webviewTitle', {
        title: title,
    });
}

/**
 * zzc api 是否存在
 * @param apiName
 * @returns {boolean}
 */
export const isApiExist = apiName => {
    return !!(window.zzc && window.zzcjsbridge && window.zzcjsbridge[apiName]);
};

/**
 * 检查用户手机是否安装了某 APP
 * @param iosAppName
 * @param androidAppName
 * @returns {Promise<unknown>}
 */
export const isAppExist = (iosAppName, androidAppName) => {
    return new Promise(resolve => {
        if (!isApiExist('base_phoneIsExistApp')) {
            resolve(false);
            return;
        }

        try {
            // window.ZZCFL 可能会不存在？
            const appName = window.ZZCFL.Utils.UA.os.name === 'ios' ? iosAppName : androidAppName;

            window.zzc.call('base_phoneIsExistApp', {
                appName: appName, // android 传包名 ，ios 用协议头
                success: response => {
                    resolve(response.data);
                },
            });
        } catch (e) {
            resolve(false);
        }
    });
};

/**
 * 是否安装了 支付宝
 * @returns {Promise<unknown>}
 */
export const isAlipayAppExist = () => isAppExist('alipay://', 'com.eg.android.AlipayGphone');

/**
 * 是否安装了 淘宝
 * @returns {Promise<unknown>}
 */
export const isTaoBaoAppExist = () => isAppExist('tbopen', 'com.taobao.taobao');

/**
 * 是否安装了 微信
 * @returns {Promise<unknown>}
 */
export const isWeChatAppExist = () => isAppExist('weixin://', 'com.tencent.mm');

/**
 * 是否安装了 拼多多
 * @returns {Promise<unknown>}
 */
export const isPddAppExist = () => isAppExist('pinduoduo://', 'com.xunmeng.pinduoduo');

/**
 * 是否安装了 美团
 * @returns {Promise<unknown>}
 */
export const isMeituanAppExist = () => isAppExist('iMeituan', 'com.sankuai.meituan');

/**
 * 是否安装了 抖音
 * @returns {Promise<unknown>}
 */
export const isDouyinAppExist = () => isAppExist('snssdk1128://', 'com.ss.android.ugc.aweme');

export function openMiniProgram(opt) {
    return zzcCall('openMiniProgram', {
        platform: '1',
        type: '0',
        ...opt,
    });
}

/**
 * 打开微信小程序（自动识别域名打开对应版本）
 * @param {*} appId 原始id
 * @param {*} path 小程序路径
 * @param {*} locationType 跳转环境

 */
export function gotoWxMiniProgram({ appId, path, type }) {
    const origin = location.origin;
    return new Promise(resolve => {
        if (!canUse('openMiniProgram')) {
            resolve(false);
            return;
        }
        zzcCall('openMiniProgram', {
            appId,
            path,
            platform: '1',
            type: type || (origin.includes('box') || origin.includes('test') ? '2' : '0'),
        })
            .then(res => {
                if (res.state === 0) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            })
            .catch(() => {
                resolve(false);
            });
        // if (env.isAndroid) {
        // android没有失败回调，如果3秒内没有打开就说明失败
        const timeId = setTimeout(() => {
            off();
            resolve(false);
        }, 3000);
        // 监听页面状态，如果3秒内被隐藏，说明唤醒了app，就清除定时器
        const off = onVisibilityChange(isShow => {
            if (!isShow) clearTimeout(timeId);
            off();
            resolve(true);
        });
        // }
    });
}

/**
 * 打开小程序
 * @param {*} param0
 */
export function openWxMiniProgram({ appId, path, updateShowFn, updateCancelFn, updateConfirmFn }) {
    if (window.isAPP && compareVersion(getAppVersion(), '1.25.0') < 0) {
        window.ZZCFL.Dialog(
            {
                title: '您APP当前版本不支持该功能，请您更新至最新版本后参与，立即更新吧~~',
                showCancelButton: true,
                confirmButtonText: '立即更新',
            },
            res => {
                if (res == 'confirm') {
                    window.location.href = `${config.appDownloadUrl}`;
                }
            }
        );
        return false;
    } else if (!window.isAPP) {
        updateShowFn && updateShowFn();
        window.ZZCFL.Dialog(
            {
                title: '当前操作仅支持在最新版本APP上进行，赶紧下载全球购骑士卡APP参与拼团活动吧~',
                showCancelButton: true,
                confirmButtonText: '立即下载',
            },
            res => {
                if (res == 'confirm') {
                    updateConfirmFn && updateConfirmFn();
                    window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.black.unique';
                } else {
                    updateCancelFn && updateCancelFn();
                }
            }
        );
        return false;
    }
    return new Promise(resolve => {
        accountAppSocialSnsLogin().then(res => {
            if (+res.state !== 0) {
                window.ZZCFL.Toast('微信授权失败');
                return;
            }
            window.zzc.call('openMiniProgram', {
                appId,
                path,
                platform: '1',
                type: '0',
                // type: '2',
                success: function(res) {
                    resolve(res);
                },
            });
        });
    });
}

/**
 * 百川 SDK 再次升级版本...
 * 通过百川SDK跳转到淘宝页面
 */
export function showTaoBaoWebPageV3(data) {
    console.log('call native : showAli_TradePage v3');
    return new Promise(resolve => {
        // 完整的参数
        const params = {
            code: '', // 打开电商套件页面
            url: '', // 打开普通电商页面
            openType: 0, // // 打开类型， 枚举类型，提出单独设置 0 native 1 自动
            degradeType: 0, // 降级方式 0-下载  1-自定义H5   2-不处理
            // 业务参数
            bizParams: {
                id: '', // 商品id（详情页面必传）
                shopId: '', // 店铺id（店铺页面必传）
                sellerId: '', // 卖家id（店铺页面必传）
                extParams: {}, // 扩展业务参数（涉及到联盟侧诸如返佣比例等参数，具体含义及获取会在分佣相关部分说
            },
            // 页面打开方式自定义参数
            showParams: {
                isPushBCWebView: false, // push方式打开
                backUrl: 'alisdk://', // 小把手
                degradeUrl: '', // 支持唯一自定义的降级url
                title: '', // 标题
                clientType: 'taobao', // 唤端类型：手淘：taobao，天猫：tmall
            },
            // 淘客参数
            taokeParams: {
                pid: '', // 1、淘客广告位 2、取消了原来adzoneId + appkey的方式 3、分佣必传，如果不传，将不会进行转链，采用原始链接加载页面
                subPid: '', // 三方的淘客广告位（可选参数）
                unionId: '', // 淘客unionId
                relationId: '', // 渠道id（非必填项）
                materialSourceUrl: '', // 媒体物料来源url（非必填项）：数据链路的回溯支持
                extParams: {}, // 扩展参数(分佣相关的)
            },
            // 链路跟踪参数（自定义、可缺省）
            trackParams: {},
        };

        window.zzc.call('showAli_TradePage_New', {
            params: JSON.stringify(Object.assign(params, data)),
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 获取授权,默认获取微信授权
 * 要第三方登录的平台,目前只有wechat一种
 */
export function accountAppSocialSnsLogin(platform = 'wechat') {
    return new Promise(resolve => {
        if (!canUse('account_appSocialSnsLogin')) {
            resolve(false);
            return;
        }

        // window.zzc.call('account_appSocialSnsLogin', {
        //     platform, // 要第三方登录的平台,目前只有wechat一种
        //     success: response => {
        //         console.log('response', response);
        //         resolve(response);
        //     },
        // });
        // 上面的写法，授权失败不会跑进success，
        window.zzcjsbridge.account_appSocialSnsLogin({
            platform,
            success: response => {
                resolve(typeof response === 'string' ? JSON.parse(response) : response);
            },
        });
    });
}

/**
 * 获取头部
 */
export function getNotchHeight() {
    if (window.zuzuche && window.zuzuche.getNotchHeight) {
        return window.zuzuche.getNotchHeight() / window.devicePixelRatio;
    }
    return 0;
}

/**
 * 设置头部导航动画
 */
export function setSearchBarState(options) {
    return new Promise(resolve => {
        window.zzc.call('base_SetSearchBarState', {
            startOffset: '20',
            endOffset: '100',
            ...options,
            success: resolve,
        });
    });
}

/**
 * 扫码，兼容了了app插件和微信插件
 */
export function scanCode(opt) {
    return new Promise((resolve, reject) => {
        if (env.isWechat) {
            window.wx.ready(function() {
                window.wx.scanQRCode({
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
                    ...opt,
                    success: res => resolve(res.resultStr),
                    error: reject,
                });
            });
            return;
        }
        zzcCall('native_scan', { ...opt })
            .then(function(respone) {
                if (env.isIos) {
                    resolve(respone.message);
                } else if (env.isAndroid) {
                    resolve(respone.data);
                }
            })
            .catch(reject);
    });
}

/**
 * 复制内容
 */
export function copyContent(content) {
    return new Promise(resolve => {
        window.zzc.call('base_setNativeClipboard', {
            content: content,
            alertContent: '复制成功!', //可选
            success: function(response) {
                console.log(response);
                resolve();
            },
        });
    });
}

export function oneKeyLogin() {
    return new Promise(resolve => {
        window.zzc.call('onekeyLogin', {
            success(response) {
                resolve(response);
            },
        });
    });
}

export function customNavbarLeftButton(params = {}) {
    return new Promise(resolve => {
        window.zzc.call('base_customNavbarLeftButton', {
            ...params,
            success() {
                resolve();
            },
        });
    });
}

/**
 * 调用客户端分享
 */
export function share(params) {
    return new Promise(resolve => {
        window.zzc.call('base_share', {
            ...params,
            success() {
                resolve();
            },
        });
    });
}
/**
 * GrowingIO统计事件埋点
 * @param {String} action 埋点事件标识符、页面级变量上报事件(PageVariable)、转化变量(Evariable)、登录用户id+变量(PeopleVariable)
 * @param {*} dataStr 自定义上报字段
 */
export function growingIoPoint({ action = '', dataStr }) {
    let param = dataStr;
    if (param instanceof Object) {
        param = JSON.stringify(param);
    }
    return new Promise(resolve => {
        if (!canUse('growingIO')) {
            return;
        }
        window.zzc.call('growingIO', {
            action,
            dataStr: param,
            success: respone => {
                resolve(respone);
            },
        });
    });
}

/**
 * 跳转到首页
 */
export function goHome(options = {}) {
    console.log('call native : base_backToHome');
    return new Promise(resolve => {
        let { tabIndex = 'shouye' } = options;
        window.zzc.call('base_backToHome', {
            tabIndex: tabIndex,
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 原生登录弹窗
 * @param {String} targetUrl 登录完成后跳转页面路径 默认跳当前页
 */
export function gotoLogin(targetUrl = window.location.href) {
    console.log('call native : jumpLogin');
    return new Promise(resolve => {
        if (!canUse('jumpLogin')) resolve();
        window.zzc.call('jumpLogin', {
            data: { targetUrl },
            success: function(response) {
                resolve(response);
            },
        });
    });
}

/**
 * 打开京东
 */
export async function openJdAppWebview(url) {
    if (!canUse('jd_openAppWebViewPage')) {
        console.error('不存在jd_openAppWebViewPage');
        return false;
    }
    const res = await zzcCall('base_phoneIsExistApp', {
        appName: env.isAndroid ? 'com.jingdong.app.mall' : 'jdlogin',
    });
    if (!res.data) {
        return false;
    }
    const appRes = await zzcCall('jd_openAppWebViewPage', {
        url,
    });

    // 1和2，才是成功
    if (appRes.data.status !== 0 && appRes.data.status !== 1) {
        return false;
    }

    return true;
}

/**
 *
 * @param {*} params
 * @returns
 */
export function setStatusBarTextStyle(params) {
    return zzcCall('base_setStatusColor', params);
}

/**
 * 跳转到设置页面
 */
export function jumpSetting() {
    return new Promise(resolve => {
        window.zzc.call('jump_permission_setting', {
            success: function(response) {
                resolve(response);
            },
        });
    });
}
/**
 * 获取设备信息
 */
export function getDeviceInfo() {
    return new Promise(resolve => {
        window.zzc.call('getUploadDeviceInfo', {
            success: function(response) {
                console.log(response);
                resolve(response);
            },
        });
    });
}
